module.exports = __webpack_public_path__ + "static/img/kslj@2x.0858df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/kslj@2x.png
// module id = N91Y
// module chunks = 1